import axios from "axios";

import _get from "lodash/get";
import _map from "lodash/map";

export default {
    requestProduct: function (id, qty) {

        if (undefined === qty) qty = 1;

        const url = `${process.env.REACT_APP_API}api/v4/variants/${id}/${qty}`;

        return request(url, transformer);
    },
    requestBundle: function (bundleId, qty, variantIds) {

        if (undefined === qty) qty = 1;

        const url = `${process.env.REACT_APP_API}api/v4/bundles/${bundleId}/${qty}/${variantIds}`;

        return request(url, transformer);
    }
}

const request = (url, callback) => {
    const instance = axios.create({
        timeout: 120000
    });
    return instance.get(url).then(callback);
};

const transformer = response => {

    const data = _get(response, 'data.data', null);

    const is_bundle = _get(data, 'is_bundle', false);

    return !data ? null : {
        id: is_bundle ? data.variant_id.toString() + '-'+ _get(data, 'bundle_variants', '') : data.variant_id.toString(),
        content: {
            is_bundle: is_bundle,
            is_digital: data.is_digital,
            bundleVariants: _get(data, 'bundle_variants', null),
            name: data.name,
            image: _get(data, 'image.src', data.background_image),
            currencies: data.currencies,
            variants: variantListTransformer(_get(data, 'variants', null))
        },
        product_id: data.id,
        seller_id: data.seller_id,
        seller_name: data.seller_name,
        shipping_zones: data.shipping_zones,
        qty: data.qty
    };
};

const variantListTransformer = variants => _map(variants, variant => {
    return {
        name: variant.name,
        image: _get(variant, 'image.src', variant.background_image)
    }
});